import axios from 'axios';
import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { Label, Input } from 'reactstrap'
import { awsConfigration, BuildingLink, environment, myBucket, REGION, S3_BUCKET } from '../../env';
import { loaderAction, successModalToggle } from '../../redux/actions/Index';
import ErrorComponents from '../errorComponents/ErrorComponents';
import AWS from 'aws-sdk'
import DocNameAddModal from './DocNameAddModal';
import { useEffect } from 'react';

window.Buffer = window.Buffer || require("buffer").Buffer;

function InvestorUploadModal(props) {

    // List useState Here
    const [modal, setModal] = useState(false);
    const [update, setUpdate] = useState(false);

    const toggle = () => setModal(!modal);

    //  redux Here

    const dispatch = useDispatch();
    const docsNameList = useSelector((state) => state?.ModalReducer?.docnameslist);

    // useForm Here
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const documenturl = async (data) => {
        var date = Math.round(+new Date() / 1000);
        const params = {
            ACL: "public-read",
            Body: data[0],
            Bucket: S3_BUCKET,
            Key: `${date}_${data[0].name}`,
        };

        myBucket.upload(params, function (err, uploadData) {
            if (uploadData) {
                data = uploadData.Location;
                return (data);
            } else {
                console.log("error", err);
            }
        });
    }

    const onSubmit = async (data) => {
        var date = Math.round(+new Date() / 1000);
        const UploadDoc = new FormData();
        UploadDoc.append('investor', props?.investor)
        UploadDoc.append('documentname', data?.documentname)
        UploadDoc.append("documenturl", `${BuildingLink}${date}_${data.document[0].name}`);
        await documenturl(data.document)
        dispatch(loaderAction(true))
        try {
            const UploadDocURL = `${environment.baseUrl}investor-doc`;
            axios.post(UploadDocURL, UploadDoc).then((docresponse) => {
                if (docresponse.data.code === 200) {
                    dispatch(successModalToggle());
                    dispatch(loaderAction(false))
                    toggle();
                    reset();
                }
            })
        } catch (error) {
            dispatch(loaderAction(false))
        }
    }

    const CancelButton = () => {
        toggle();
        reset();
    }
    return (
        <>
            <Button onClick={toggle} className='border-radius-7 px-3 d-flex align-items-center buttons py-3 flex-nowrap'><span className='fs-4 d-flex gap-3 title-font-600 ps-3 pe-2'>Upload</span></Button>
            <Modal className='border-0' isOpen={modal} toggle={props.toggle} size="md" centered>
                <ModalHeader className='bg-base-color '><span className='title-font-700 fs-36 text-base-white'>Upload Documents</span></ModalHeader>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <ModalBody className='bg-background-color px-5'>
                        <div className="row align-items-center">
                            <div className="col-10 mx-auto  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                                    Document Name *
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <select
                                        id="documentname"
                                        name="role_type"
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        {...register("documentname", { required: true })}
                                    >
                                        <option value="">Select</option>
                                        {docsNameList?.map((data, i) => {
                                            return (
                                                <option value={data.doc_name} key={i}>{data.doc_name}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                                {errors.documentname && (
                                    <ErrorComponents error={"Document Name is required *"} />
                                )}
                                <br />
                            </div>
                            <div className='col-2 mx-auto mx-md-0'>
                                <DocNameAddModal upload={true} />
                            </div>
                            <div className='col-12 mx-auto  pb-3 pt-1  mx-md-0'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                                    Upload Documents *
                                </Label>
                                <br />
                                <div className='mt-1 d-flex gap-3'>
                                    <input
                                        className='border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input bg-white'
                                        type='file'
                                        placeholder='Upload Documents...'
                                        {...register("document", { required: true })}
                                    />
                                </div>
                                {errors.document && <ErrorComponents error={'Document is required *'} />}
                                <br />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3' >Cancel</span></Button>{' '}
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons'><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Upload</span></Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};


export default InvestorUploadModal